<div class="dates-filter-container p-3">
  <div class="col-8 offset-2 mb-3">
    <select
      class="form-select"
      [(ngModel)]="app.datesFilter.model.dateMode"
      (ngModelChange)="onDateModeChange($event)"
      aria-label="Default select example"
    >
      <option [ngValue]="'specific'" selected>
        {{ app.text.manufacturer.specificDate }}
      </option>
      <option [ngValue]="'interval'">
        {{ app.text.manufacturer.dateInterval }}
      </option>
    </select>
  </div>

  <!-- Row 1: Specific Date -->
  <div
    class="row mb-3 align-items-center"
    *ngIf="app.datesFilter.model.dateMode === 'specific'"
  >
    <label class="col-5 col-form-label">{{
      app.text.manufacturer.specificDate
    }}</label>
    <div class="col-7">
      <div class="input-group">
        <input
          class="form-control"
          [(ngModel)]="app.datesFilter.model.specificDate"
          name="specificDate"
          ngbDatepicker
          #specificDate="ngbDatepicker"
          placeholder="YYYY-MM-DD"
        />
        <button
          class="btn btn-outline-secondary calendar-btn"
          type="button"
          (click)="specificDate.toggle()"
        >
          <i class="fa fa-calendar"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Row 2: Date Range -->
  <div *ngIf="app.datesFilter.model.dateMode === 'interval'">
    <div class="row mb-3 align-items-center">
      <label class="col-5 col-form-label">{{
        app.field.getLabel(app.fieldId.manufacturer.from)
      }}</label>
      <div class="col-7">
        <div class="input-group">
          <input
            class="form-control"
            [(ngModel)]="app.datesFilter.model.fromDate"
            name="fromDate"
            ngbDatepicker
            #fromDate="ngbDatepicker"
            placeholder="YYYY-MM-DD"
          />
          <button
            class="btn btn-outline-secondary calendar-btn"
            type="button"
            (click)="fromDate.toggle()"
          >
            <i class="fa fa-calendar"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-3 align-items-center">
      <label class="col-5 col-form-label">{{
        app.field.getLabel(app.fieldId.manufacturer.to)
      }}</label>
      <div class="col-7">
        <div class="input-group">
          <input
            class="form-control"
            [(ngModel)]="app.datesFilter.model.toDate"
            name="toDate"
            ngbDatepicker
            #toDate="ngbDatepicker"
            placeholder="YYYY-MM-DD"
          />
          <button
            class="btn btn-outline-secondary calendar-btn"
            type="button"
            (click)="toDate.toggle()"
          >
            <i class="fa fa-calendar"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Action Buttons Row -->
  <div class="row mt-4">
    <div class="col-12 d-flex justify-content-center gap-3">
      <button class="btn btn-orange" (click)="onApply()">
        {{ app.text.app.apply }}
      </button>
    </div>
  </div>
</div>
